module.exports = __webpack_public_path__ + "static/img/p2.c50b9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p2.png
// module id = ndtA
// module chunks = 0